import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const BackgroundLogin = styled.div`
  background: var(--secondary);
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 20vh 0;
  height: 100vh;
  box-shadow: var(--box-shadow);
  @media (max-width: 1200px) {
    padding: 10vh 0;
  }
`;

export const Copyright = styled.p`
  color: #fff;
  text-align: center;
  font-family: 'GothamBold';
  font-size: 1.4rem;
`;

export const UserForm = styled(Unform)`
  width: 70%;
  margin: 64px 32px;
  display: grid;

  h1 {
    font-size: 1.4rem;
    color: #fff;
    text-align: center;
    font-family: 'GothamBold';
  }

  span {
    font-size: 14px;
    color: #fff;
    font-family: 'GothamBold';
  }

  @media (max-width: 1200px) {
    width: 85%;
  }
`;

export const InputLogin = styled.input`
  color: #fff;
  width: 100%;
  height: 50px;
  margin: 10px auto;
  border: 1px solid white;
  border-radius: 4px;
  background: transparent;
  text-indent: 10px;
  &::placeholder {
    color: #fff;
    font-size: 1.4rem;
  }
`;

export const SubmitButton = styled.button`
  background: var(--primary);
  border: none;
  border-radius: 4px;
  padding: 10px 4px;
  width: 100%;
  margin: 10px auto;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: wait;
    background-color: #ccc;
  }
`;

export const Logo = styled.img`
  width: 300px;
  object-fit: cover;
  @media (max-width: 1200px) {
    width: 250px;
  }
`;
